import { Reducer } from 'redux';

import { UploadState } from './types';

const defaultState: UploadState = {
    uploading: false,
    progress: 0,
};

const reducer: Reducer<UploadState> = (state = defaultState, action): UploadState => {
    const { payload, type } = action;
    switch (type) {
        case '@@upload/UPLOAD_FILES_START':
            return {
                ...state,
                ...{
                    uploading: true,
                    progress: 0,
                },
            };
        case '@@upload/UPLOAD_ERROR':
            return {
                uploading: false,
                progress: 0,
            };
        case '@@upload/UPLOAD_SUCCESS':
            return {
                uploading: false,
                progress: 100,
                ...{ fileuploaded: payload.fileuploaded },
            };
        case '@@upload/UPLOAD_FILE_PROGRESS_UPDATE':
            return {
                ...state,
                ...{
                    progress: payload.progress,
                },
            };
        case '@@upload/DELETE_FILE':
            return { ...state, ...action.payload };
        case '@@upload/UPLOAD_FILES':
        case '@@uploadmedia/UPLOAD_FILES':
        default:
            return state;
    }
};

export { reducer as upload };

export default reducer;
